export default __webpack_public_path__ + "static/media/dashboardEllipsesRed.e5bac715.svg";